import { headerStyles as styles } from "@iewccouk/Overrides/Pages/Header";
import { calcInitialWidth, colorStrings, mediaQueriesBP } from "@iewccouk/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.page = {
    css: css`
        ${mediaQueriesBP.maxLG} {
            overflow: visible;
        }
    `,
};

styles.container = {
    css: css`
        background-color: ${getColor(colorStrings.commonGlobalGray03)};
        color: ${getColor(colorStrings.textMain)};
        display: flex;

        ${mediaQueriesBP.minLG} {
            position: relative;

            &::before {
                content: "";
                background-color: ${getColor(colorStrings.commonGlobalGray03)};
                border: 1px solid ${getColor(colorStrings.commonGlobalGray03)};
                position: absolute;
                height: 100%;
                width: ${calcInitialWidth};
                left: 50%;
                transform: translateX(-50%);
            }
        }
    `,
};
